"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const snap_ui_1 = require("@teamsnap/snap-ui");
const teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
const lodash_1 = require("lodash");
const React = __importStar(require("react"));
const useNavigation_1 = require("src/hooks/useNavigation");
const layouts_1 = require("../shared/layouts");
const useManagePlan_1 = require("./useManagePlan");
/**
 * The user subscription also uses an identical UI, so when making
 * updates, it might be good to update the other one as well.
 */
const ManageTeamPlan = () => {
    const { paymentMethods, liteTeam, teamPlan, isProcessing, createPaymentMethod, setTeamSubscriptionPaymentMethod, selectedId, addingMethod, } = (0, useManagePlan_1.useManagePlan)();
    const { navigate } = (0, useNavigation_1.useNavigation)();
    return (React.createElement(layouts_1.BasicWrapperBack, { onBack: () => navigate.classicTeamBilling() },
        React.createElement(layouts_1.FormWrapper, null,
            React.createElement("div", { className: "sui-heading-md sui-mb-2", "data-testid": "update-payment-heading" }, "Update Payment Method"),
            React.createElement("div", { className: "sui-heading-sm" }, teamPlan?.metadata?.name),
            React.createElement("div", { className: "sui-mb-2" }, liteTeam?.name),
            !!paymentMethods && paymentMethods.length > 0 && (React.createElement("div", { className: "sui-mb-2 sui-caption sui-text-neutral-text-medium" }, "Select a method:")),
            !!paymentMethods && paymentMethods.length === 0 && (React.createElement("div", { className: "sui-mb-2 sui-caption sui-text-neutral-text-medium" }, "No payment methods found")),
            !paymentMethods && (React.createElement("div", { className: "sui-mb-2 sui-caption sui-text-neutral-text-medium" },
                "loading payment methods ",
                React.createElement(teamsnap_ui_1.Loader, { type: "pulse", size: { height: 16, width: 16 } }))),
            React.createElement("div", { className: "sui-mb-2" },
                !!paymentMethods &&
                    paymentMethods.map((method) => (React.createElement("button", { "data-testid": `payment-method-${method.id}`, className: `sui-border sui-border-solid sui-rounded sui-p-2 sui-mb-2 sui-w-full sui-bg-white ${method.id === selectedId
                            ? 'sui-border-action-background sui-cursor-default'
                            : 'sui-border-neutral-background-disabled sui-cursor-pointer'}`, key: method.id, onClick: method.id === selectedId || isProcessing
                            ? () => { }
                            : () => setTeamSubscriptionPaymentMethod(method.id) },
                        method.id === selectedId && (React.createElement("div", { className: "sui-flex sui-justify-between" },
                            React.createElement(snap_ui_1.Status, { state: "info" }, "Current Method"),
                            React.createElement("span", { className: "sui-flex sui-items-center sui-text-neutral-text-disabled" },
                                React.createElement(snap_ui_1.Icon, { name: "check" }),
                                "Selected"))),
                        React.createElement("div", { className: "sui-flex sui-justify-between sui-items-center sui-mb-1" },
                            React.createElement("span", { className: "sui-heading-sm" },
                                (0, lodash_1.capitalize)(method.card?.brand),
                                " ending in ",
                                method.card?.last4),
                            method.id !== selectedId && (React.createElement("span", { className: isProcessing ? 'sui-text-neutral-text-disabled' : 'sui-text-action-text' }, "Select"))),
                        React.createElement("div", { className: "sui-caption sui-text-neutral-text-medium  sui-text-left" },
                            "Expires",
                            ' ',
                            method.card?.expiration?.month !== undefined &&
                                (method.card.expiration.month < 10
                                    ? `0${method.card.expiration.month}`
                                    : method.card.expiration.month),
                            "/",
                            method.card?.expiration?.year)))),
                React.createElement(snap_ui_1.LabelButton, { "data-testid": "add-payment-method", className: "sui-w-full", onClick: createPaymentMethod, labelText: "Add a new payment method", disabled: isProcessing && !addingMethod, loading: isProcessing && addingMethod })))));
};
exports.default = ManageTeamPlan;
